// extracted by mini-css-extract-plugin
export default {"brandPromo":"jG-z","carousel":"kG-z"};